import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 700) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    // Use the same classes as the legacy script: "back-top" and "back-top-visible" (if we want to use existing CSS)
    // The existing CSS likely uses .back-top and .back-top-visible
    // Based on style.css lines 1459+, .back-top is the class.

    return (
        <a
            href="#top"
            className={`back-top ${isVisible ? 'back-top-visible' : ''}`}
            onClick={scrollToTop}
            style={{ display: 'inline' }} // Ensure it's not hidden by default CSS if visible
        >
            <i className="fa fa-angle-up"></i>
        </a>
    );
};

export default ScrollToTopButton;
